module.exports = __webpack_public_path__ + "static/media/25682_1380851608050_2128664_n.418d42f6.jpg";